import React, { useState } from "react";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import HeroImage from "../../../assets/Home_image.png";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { SingleDatePicker } from "react-google-flight-datepicker";
import "react-google-flight-datepicker/dist/main.css";

import Classes from "./Style.module.css";

import "./date-picker.css";

const dateToString = (date) => {
  const strings = date.toDateString().split(" ");
  return `${strings[1]}-${strings[2]}-${strings[3]}`;
};

var settings = {
  dots: true,
  infinite: true,
  speed: 2000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  pauseOnHover: false,
  fade: true,
};
const Index = () => {
  const [bookData, setBookData] = useState({
    startDate: new Date(Date.now()),
    endDate: new Date(new Date(Date.now()).getTime() + 24 * 60 * 60 * 1000),
    totalGuest: 1,
  });

  const [changeListener, setChangeListener] = useState({
    startDate: false,
    endDate: false,
  });

  const onBookDataChangeHandler = (field, newValue) => {
    setBookData((prev) => {
      const old = { ...prev };
      old[field] = newValue;
      return old;
    });
  };
  console.log(bookData.startDate.toDateString());
  return (
    <div data-aos="zoom-in" className={Classes.hero_container}>
      <div style={{ position: "relative" }}>
        <Slider {...settings}>
          <div className={Classes.hero}>
            <img src={HeroImage} alt="Hero" className={Classes.hero_image} />
            <div className={Classes.hero_text}>
              <h2>Book Today</h2>
              <h1>Best Rate Guarantee</h1>
              <p>We guarantee ​you’ll find the lowest price here.</p>
            </div>
          </div>
          <div className={Classes.hero}>
            <img src={HeroImage} alt="Hero" className={Classes.hero_image} />
            <div className={Classes.hero_text}>
              <h2>Enjoy Weekend</h2>
              <h1>Best View Here!</h1>
              <p>We guarantee ​you’ll find your Best comfort here.</p>
            </div>
          </div>
        </Slider>
        <div className={`${Classes.dates} dates_picker`}>
          <label className={Classes.dates_items}>
            <p>
              {changeListener.startDate
                ? dateToString(bookData.startDate)
                : "Check In"}
            </p>
            <ExpandMoreIcon className={Classes.dates_items_icons} />
            <SingleDatePicker
              startDate={bookData.startDate}
              onChange={(e) => {
                onBookDataChangeHandler(
                  "startDate",
                  new Date(new Date(e).getTime())
                );
                if (!changeListener.startDate) {
                  setChangeListener((prev) => {
                    const old = { ...prev };
                    old.startDate = true;
                    return old;
                  });
                }
              }}
              className={Classes.date_picker}
            />
          </label>
          <label className={Classes.dates_items}>
            <p>
              {changeListener.endDate
                ? dateToString(bookData.endDate)
                : "Check In"}
            </p>
            <ExpandMoreIcon className={Classes.dates_items_icons} />
            <SingleDatePicker
              startDate={bookData.endDate}
              onChange={(e) => {
                onBookDataChangeHandler(
                  "endDate",
                  new Date(new Date(e).getTime())
                );
                if (!changeListener.endDate) {
                  setChangeListener((prev) => {
                    const old = { ...prev };
                    old.endDate = true;
                    return old;
                  });
                }
              }}
              className={Classes.date_picker}
            />
          </label>
          <label for="select" className={Classes.dates_items}>
            <div className={`select`}>
              <select
                onChange={(e) => {
                  onBookDataChangeHandler("totalGuest", e.target.value);
                }}
                id="select"
                name="select"
                value={bookData.totalGuest}
                className={"select_guest"}
              >
                {[
                  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                  19, 20,
                ].map((ele) => (
                  <option key={ele} value={ele}>
                    {ele} Guest{ele > 1 ? "s" : ""}
                  </option>
                ))}
              </select>
            </div>
            <ExpandMoreIcon className={Classes.dates_items_icons} />
          </label>
          <button className={`btn_primary ${Classes.dates_items}`}>
            Check Rates
          </button>
        </div>
      </div>
    </div>
  );
};

export default Index;
